module.exports = __webpack_public_path__ + "static/media/pixeled-box-yellow.2537d260.svg";